import * as React from "react";
import { Wallet } from "lucide-react";
import { UniversalSelector } from "@/components/ui/universal-selector";

interface PaymentMethod {
  id: string;
  name: string;
}

interface PaymentMethodSelectorProps {
  paymentMethods: PaymentMethod[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  allowFreeText?: boolean;
  freeTextValue?: string;
  onFreeTextChange?: (value: string) => void;
  label?: string;
  error?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onEnterPress?: () => void;
  required?: boolean;
  canAddNew?: boolean;
  onAddNew?: (name: string) => Promise<void>;
}

export function PaymentMethodSelector({
  paymentMethods,
  value,
  onValueChange,
  placeholder = "Selecione uma forma de pagamento",
  allowFreeText = false,
  freeTextValue = "",
  onFreeTextChange,
  label = "Forma de Pagamento",
  error,
  inputRef,
  onEnterPress,
  required = true,
  canAddNew = false,
  onAddNew
}: PaymentMethodSelectorProps) {
  
  return (
    <UniversalSelector
      items={paymentMethods}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      allowFreeText={allowFreeText}
      freeTextValue={freeTextValue}
      onFreeTextChange={onFreeTextChange}
      label={label}
      error={error}
      inputRef={inputRef}
      onEnterPress={onEnterPress}
      icon={Wallet}
      required={required}
      canAddNew={canAddNew}
      onAddNew={onAddNew}
      addNewLabel="Adicionar Nova Forma de Pagamento"
    />
  );
}